import { createRouter, createWebHistory } from "vue-router";
import { loginGuard } from "@shared/router/loginGuard";
import { baseRoutes } from "@shared/baseRoutes";
import { userManagementRoutes } from "@shared/userManagement/router";
import { knowledgeSpacesRoutes } from "@shared/knowledgeSpaces/routes";

const routes = [
  ...baseRoutes,
  ...userManagementRoutes,
  ...knowledgeSpacesRoutes,
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/login/openId-callback",
    name: "loginOpenIdCallback",
    component: () => import("../views/LoginOpenIdCallback.vue"),
  },
  {
    path: "/apps-admin/",
    name: "appsAdmin",
    component: () => import("@shared/components/apps/AppsSettings.vue"),
    meta: {
      appClientId: "smx-portal",
      breadcrumbs: [
        {
          label: "appsAdmin",
          route: { name: "appsAdmin" },
        },
      ],
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(loginGuard);

export default router;
